import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import QuranDetail from '../views/QuranDetail.vue'
import Login from '../views/Login.vue'
import Bookmark from '../views/Bookmark.vue'
import Khazanah from '../views/Khazanah/Index.vue'
import KhazanahDetail from '../views/Khazanah/Detail.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: { 
            title: "Quran",
            isBack: false
        }
    },
    {
        path: '/quran/surah/:id',
        name: 'quran.detail',
        component: QuranDetail,
        props: true,
        meta: { 
            title: "Quran Detail" ,
            isBack: true
        }
    },
    {
        path: '/khazanah',
        name: 'khazanah.index',
        component: Khazanah,
        meta: { 
            title: "Khazanah",
            isBack: false
        }
    },
    {
        path: '/khazanah/detail/:id',
        name: 'khazanah.detail',
        component: KhazanahDetail,
        props: true,
        meta: { 
            title: "Khazanah Detail" ,
            isBack: true
        }
    },
    {
        path: '/bookmark',
        name: 'bookmark',
        component: Bookmark,
        meta: { 
            title: "Bookmark",
            isBack: false
        }
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: { 
            title: "Login",
            isBack: false
        }
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router